export { default as HeaderV2 } from './header-v2.component';
